const validator = {
  getMessage: () =>
    `Number is invalid. It should start with '3/6/8/9' and have 8 digits.`,
  validate: value => /^[3689]\d{7}$/.test(value)
};

export default validator;
